import React from 'react';
import { theme } from './theme';

const GlobalStyles: React.FC = () => (
    <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Playfair+Display:wght@500;600;700&display=swap');
        
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            -webkit-tap-highlight-color: transparent;
        }
        
        html {
            font-size: 16px;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
        }
        
        body {
            font-family: ${theme.fonts.primary};
            background: ${theme.colors.bgPrimary};
            color: ${theme.colors.textPrimary};
            line-height: 1.5;
            overflow-x: hidden;
            min-height: 100vh;
            min-height: -webkit-fill-available;
        }
        
        html {
            height: -webkit-fill-available;
        }
        
        /* Mobile-first responsive utilities */
        .container {
            width: 100%;
            max-width: 100%;
            padding-left: 16px;
            padding-right: 16px;
            margin: 0 auto;
        }
        
        @media (min-width: 768px) {
            .container {
                max-width: 720px;
                padding-left: 24px;
                padding-right: 24px;
            }
        }
        
        @media (min-width: 1024px) {
            .container {
                max-width: 960px;
            }
        }
        
        @media (min-width: 1280px) {
            .container {
                max-width: 1200px;
            }
        }
        
        /* Smooth scrolling */
        html {
            scroll-behavior: smooth;
        }
        
        /* Custom scrollbar */
        ::-webkit-scrollbar {
            width: 8px;
            height: 8px;
        }
        
        ::-webkit-scrollbar-track {
            background: ${theme.colors.bgSecondary};
        }
        
        ::-webkit-scrollbar-thumb {
            background: ${theme.colors.primaryLight};
            border-radius: 4px;
        }
        
        ::-webkit-scrollbar-thumb:hover {
            background: ${theme.colors.primary};
        }
        
        /* Focus styles for accessibility */
        :focus-visible {
            outline: 2px solid ${theme.colors.accent};
            outline-offset: 2px;
        }
        
        /* Animations */
        @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
        }
        
        @keyframes slideUp {
            from { 
                opacity: 0;
                transform: translateY(20px);
            }
            to { 
                opacity: 1;
                transform: translateY(0);
            }
        }
        
        @keyframes slideDown {
            from { 
                opacity: 0;
                transform: translateY(-20px);
            }
            to { 
                opacity: 1;
                transform: translateY(0);
            }
        }
        
        @keyframes scaleIn {
            from { 
                opacity: 0;
                transform: scale(0.9);
            }
            to { 
                opacity: 1;
                transform: scale(1);
            }
        }
        
        @keyframes pulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.05); }
        }
        
        @keyframes shimmer {
            0% { background-position: -200% 0; }
            100% { background-position: 200% 0; }
        }
        
        @keyframes bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-10px); }
        }
        
        @keyframes confetti {
            0% { transform: translateY(0) rotate(0deg); opacity: 1; }
            100% { transform: translateY(100vh) rotate(720deg); opacity: 0; }
        }
        
        .animate-fadeIn { animation: fadeIn 0.3s ease-out; }
        .animate-slideUp { animation: slideUp 0.4s ease-out; }
        .animate-slideDown { animation: slideDown 0.4s ease-out; }
        .animate-scaleIn { animation: scaleIn 0.3s ease-out; }
        .animate-pulse { animation: pulse 2s ease-in-out infinite; }
        .animate-bounce { animation: bounce 1s ease-in-out infinite; }
        
        /* Touch-friendly button base */
        button, .btn {
            min-height: 44px;
            min-width: 44px;
            cursor: pointer;
            touch-action: manipulation;
            user-select: none;
            border: none;
            background: none;
            font-family: inherit;
        }
        
        /* Safe area insets for notched devices */
        .safe-area-inset-top {
            padding-top: env(safe-area-inset-top);
        }
        
        .safe-area-inset-bottom {
            padding-bottom: env(safe-area-inset-bottom);
        }
        
        /* Prevent text selection during drag */
        .no-select {
            user-select: none;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
        }
        
        /* Hide on mobile/desktop */
        @media (max-width: 767px) {
            .hide-mobile { display: none !important; }
        }
        
        @media (min-width: 768px) {
            .hide-desktop { display: none !important; }
        }
    `}</style>
);

export default GlobalStyles;
